"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Slider = /** @class */ (function () {
    function Slider(rootElement) {
        var slider = rootElement.querySelector('.js-slider');
        // Logic goes here
    }
    return Slider;
}());
exports.default = Slider;
